import type { Community } from './community';
import type { User } from './user';

export const AccountType = {
  SINGLE_COMMUNITY: 'single-community',
  MANAGED: 'managed',
} as const;

export const AccountTypeLabel = {
  [AccountType.SINGLE_COMMUNITY]: 'Single Community',
  [AccountType.MANAGED]: 'Managed',
} as const;

export interface Account {
  id: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  roles: string[];
  type: (typeof AccountType)[keyof typeof AccountType];
  owner?: User;
  users: User[];
  communities: Community[];
  setup_complete: boolean;
}
